import { CSSProperties, FC, useState } from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';

import { Checkbox, RemoveCircleIconButton, TextArea } from '../../../';

import { Icon } from '../../../';

interface SettingInputProps {
  defaultValue?: string;
  defaultChecked?: boolean;
  onRemove?(this: void): void;

  onDebouncedChange?(this: void, value: string): void;
  onBlur?(this: void, value: string): void;
  onChange?(this: void, p: { value: string; checked: boolean }): void;
  styles?: CSSProperties;
  onChecked?(checked: boolean): void;
}

export const SettingInput: FC<SettingInputProps> = ({
  defaultChecked,
  defaultValue,
  onRemove,
  onChange,
  onBlur,
  styles,
  onChecked,
}) => {
  const [value, setValue] = useState(defaultValue ?? '');
  const [checked, setChecked] = useState(Boolean(defaultChecked));
  const [removed, setRemoved] = useState(false);

  const handleBlur = () => {
    onBlur?.(value);
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const updatedValue = e.target.value;
    setValue(updatedValue);
    onChange?.({ value: updatedValue, checked });
  };

  return (
    <motion.div
      variants={{
        removed: { height: 0, marginBottom: 0 },
        visible: { height: '100%' },
      }}
      animate={removed && 'removed'}
      className="mb-1 flex items-center overflow-hidden rounded-md "
      style={styles}
    >
      <motion.div
        variants={{
          removed: { height: 0 },
          visible: { height: '100%' },
        }}
        animate={removed && 'removed'}
        className="relative mr-4 flex-1"
      >
        <motion.div
          onAnimationComplete={() => {
            if (removed) onRemove?.();
          }}
          animate={removed && 'removed'}
          initial="visible"
          className={clsx('absolute z-10 h-full w-full rounded-md bg-darkMode-danger', !removed && 'hidden')}
          variants={{
            removed: { opacity: 1 },
            visible: { opacity: 0 },
          }}
        />

        <TextArea
          autosize
          defaultValue={value}
          onChange={handleChange}
          onBlur={handleBlur}
          leading={
            <Checkbox
              type="square"
              onChange={(c) => {
                setChecked(c);
                onChecked?.(c);
                onChange?.({ checked: c, value: value });
              }}
              defaultChecked={checked}
              className="mr-2 self-baseline !text-palette-500"
            />
          }
          trailing={<Icon icon="dragHandle" className="text-palette-500" />}
          name="goals"
          className={clsx('dark:!text-darkMode-gray-light', checked && 'line-through dark:!text-darkMode-gray-medium')}
        />
      </motion.div>
      <RemoveCircleIconButton onClick={() => setRemoved(true)} className="mb-1" baseColor="#FF154F" />
    </motion.div>
  );
};
